import React, {useEffect, useRef, useState} from 'react'

import {McModal} from '@maersk-global/mds-react-wrapper/components-core/mc-modal'
import {McButton} from '@maersk-global/mds-react-wrapper/components-core/mc-button'

import styles from './index.module.scss'
import Essencial from './Essencial'
import Funcional from './Funcional'
import Estatico from './Estatico'
import Publicidade from './Publicidade'
import NaoClassificados from './NaoClassificados'

interface CookieData {
  website_uuid: string
  timestamp: string
  consent_url: string
  consent_website: string
  consent_domain: string
  user_uid: string
  consents_approved: string[]
  consents_denied: string[]
  user_agent: string
}

interface CookieState {
  name: string
  status: boolean
}

const CookiesConsent: React.FC = () => {
  const dialogRef = useRef(null)

  const [modalInicial, setModalInicial] = useState(true)
  const [gerenciarCookies, setGerenciarCookies] = useState(false)
  const [showModal, setShowModal] = useState<boolean>(false)

  const [cookiesState, setCookiesState] = useState<CookieState[]>([
    {name: 'cookie_cat_necessary', status: true},
    {name: 'cookie_cat_functional', status: true},
    {name: 'cookie_cat_statistic', status: true},
    {name: 'cookie_cat_marketing', status: true},
    {name: 'cookie_cat_unclassified', status: true},
  ])

  const [consentData, setConsentData] = useState<CookieData>({
    website_uuid: '9a5b6bb4-e94e-47c7-81e7-d84ba655925f',
    timestamp: new Date().toISOString(),
    consent_url: 'https://www.alianca.com.br/vendor',
    consent_website: 'igntest.com',
    consent_domain: 'alianca.com.br',
    user_uid: 'e89ea692-a6fb-4a7e-9f3f-1eb6686a39e0',
    consents_approved: [],
    consents_denied: [],
    user_agent: '',
  })

  useEffect(() => {
    setConsentData(prevState => {
      const updatedConsentData = {...prevState}
      updatedConsentData.consents_approved = cookiesState
        .filter(c => c.status)
        .map(c => c.name)
      updatedConsentData.consents_denied = cookiesState
        .filter(c => !c.status)
        .map(c => c.name)
      return updatedConsentData
    })
  }, [cookiesState])

  useEffect(() => {
    setConsentData(prevState => {
      const getUserAgentInfoString = () => {
        const userAgent = navigator.userAgent

        const browserMatch = userAgent.match(
          /(Chrome|Firefox|Safari|Opera|MSIE|Trident)/,
        )
        const osMatch = userAgent.match(
          /(Windows NT|Macintosh|Linux|Android|iPhone)/,
        )

        const browser = browserMatch ? browserMatch[0] : 'Unknown'
        const os = osMatch ? osMatch[0] : 'Unknown'

        return `User Agent: ${userAgent}\nBrowser: ${browser}\nOperating System: ${os}`
      }

      const updatedConsentData = {...prevState}
      updatedConsentData.user_agent = getUserAgentInfoString()
      return updatedConsentData
    })
  }, [])

  useEffect(() => {
    const cookies = document.cookie.split('; ')
    const cookieObject: Record<string, string> = {}

    cookies.forEach(cookie => {
      const [name, value] = cookie.split('=')
      cookieObject[decodeURIComponent(name)] = decodeURIComponent(value)
    })

    if (!cookieObject.CookieInformationConsent) {
      setShowModal(true)
    } else {
      setModalInicial(false)
    }
  }, [])

  useEffect(() => {
    //@ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (dialogRef.current) {
      const shadowRoot = (dialogRef.current as HTMLElement).shadowRoot
      const style = document.createElement('style')
      style.textContent = `
        .mdc-dialog__surface {
          position: absolute !important;
          bottom: 0 !important;
          right: 0 !important;
        }
      `
      shadowRoot?.appendChild(style)
    }
  }, [])

  const saveAll = () => {
    const updatedConsentData = {...consentData}
    updatedConsentData.consents_approved = [
      'cookie_cat_necessary',
      'cookie_cat_functional',
      'cookie_cat_statistic',
      'cookie_cat_marketing',
      'cookie_cat_unclassified',
    ]
    updatedConsentData.consents_denied = []

    const stringfyData = JSON.stringify(updatedConsentData)
    const encodedValue = encodeURIComponent(stringfyData)
    const expirationDays = 30
    const date = new Date()
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000)
    const expires = `; expires=${date.toUTCString()}`

    document.cookie = `CookieInformationConsent=${encodedValue}${expires}; path=/`
    setShowModal(false)
  }

  const saveCustom = () => {
    const stringfyData = JSON.stringify(consentData)
    const encodedValue = encodeURIComponent(stringfyData)
    const expirationDays = 30
    const date = new Date()
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000)
    const expires = `; expires=${date.toUTCString()}`

    document.cookie = `CookieInformationConsent=${encodedValue}${expires}; path=/`
    setShowModal(false)
  }

  const saveEssencials = () => {
    const updatedConsentData = {...consentData}
    updatedConsentData.consents_approved = ['cookie_cat_necessary']
    updatedConsentData.consents_denied = [
      'cookie_cat_functional',
      'cookie_cat_statistic',
      'cookie_cat_marketing',
      'cookie_cat_unclassified',
    ]

    const stringfyData = JSON.stringify(updatedConsentData)
    const encodedValue = encodeURIComponent(stringfyData)
    const expirationDays = 30
    const date = new Date()
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000)
    const expires = `; expires=${date.toUTCString()}`

    document.cookie = `CookieInformationConsent=${encodedValue}${expires}; path=/`
    setShowModal(false)
  }

  if (!showModal) {
    return null
  }

  return (
    <div className="cookie-consent-modal">
      <McModal
        open={modalInicial}
        ref={dialogRef}
        heading="Gerenciamento de cookies para a melhor experiência digital"
        hiddenclose
        zindex={99999}
        dimension="large"
        height="300px"
        width="95%"
        fit="small"
        backdropcloseactiondisabled
        style={{position: 'absolute', bottom: '50px', marginTop: '300px'}}
        className="teste"
        escapecloseactiondisabled>
        <div style={{fontSize: '14px', color: '#545454', lineHeight: '20px'}}>
          Nosso site utiliza cookies da A.P. Moller–Maersk e suas{' '}
          <a
            target="_blank"
            href="https://investor.maersk.com/financials/financial-reports"
            rel="noreferrer">
            empresas afiliadas
          </a>{' '}
          para ajudar a tornar navegável o site, para possibilitar o
          armazenamento de informações que alteram a forma como o site aparece,
          para entender como nossos visitantes interagem no site, para
          personalizar conteúdo e para exibir a você informações mais
          pertinentes sobre nossos serviços, por meio da oferta de recursos de
          nossos parceiros e compartilhando cookies com eles.
          <br />
          <br />
          Você pode retirar seu consentimento a qualquer momento, para isto
          clicando em "Preferências de cookies" (“Cookie preferences”) no rodapé
          de nosso site. Saiba mais em nossa Política de{' '}
          <a
            target="_blank"
            href="https://terms.maersk.com/privacy"
            rel="noreferrer">
            Notificação de Privacidade
          </a>{' '}
          e{' '}
          <a
            target="_blank"
            href="https://terms.maersk.com/cookies"
            rel="noreferrer">
            Cookies
          </a>
          .
        </div>
        <a
          className={styles.link}
          style={{position: 'absolute', bottom: '5px', left: '20px'}}
          onClick={() => {
            setGerenciarCookies(!gerenciarCookies)
            setModalInicial(false)
          }}>
          Gerenciar preferências
        </a>
        <McButton
          data-cy-item="cookies-btn-essencials"
          slot="secondaryAction"
          appearance="primary"
          variant="filled"
          fit="small"
          onClick={() => saveEssencials()}>
          Apenas Essenciais
        </McButton>
        <McButton
          data-cy-item="cookies-btn-all"
          slot="primaryAction"
          appearance="primary"
          variant="filled"
          fit="small"
          onClick={() => saveAll()}>
          Permitir todos
        </McButton>
      </McModal>

      <McModal
        open={gerenciarCookies}
        ref={dialogRef}
        heading="Controles de Privacidade"
        hiddenclose
        zindex={99999}
        dimension="large"
        height="90vh"
        width="712px"
        fit="medium"
        backdropcloseactiondisabled
        style={{position: 'absolute', bottom: '50px'}}
        className="teste"
        escapecloseactiondisabled>
        <div style={{fontSize: '14px', color: '#545454', lineHeight: '20px'}}>
          Nosso site utiliza cookies da A.P. Moller–Maersk e suas{' '}
          <a
            target="_blank"
            href="https://investor.maersk.com/financials/financial-reports"
            rel="noreferrer">
            empresas afiliadas
          </a>{' '}
          para ajudar a tornar navegável o site, para possibilitar o
          armazenamento de informações que alteram a forma como o site aparece,
          para entender como nossos visitantes interagem no site, para
          personalizar conteúdo e para exibir a você informações mais
          pertinentes sobre nossos serviços, por meio da oferta de recursos de
          nossos parceiros e compartilhando cookies com eles.
          <br />
          <br />
          Você pode retirar seu consentimento a qualquer momento, para isto
          clicando em "Preferências de cookies" (“Cookie preferences”) no rodapé
          de nosso site. Saiba mais em nossa Política de{' '}
          <a
            target="_blank"
            href="https://terms.maersk.com/privacy"
            rel="noreferrer">
            Notificação de Privacidade
          </a>{' '}
          e{' '}
          <a
            target="_blank"
            href="https://terms.maersk.com/cookies"
            rel="noreferrer">
            Cookies
          </a>
          .
        </div>
        <div className="content">
          <Essencial />
          <Funcional
            handleChangeCookie={(cookie: string, value: boolean) =>
              setCookiesState(prevState =>
                prevState.map(i =>
                  i.name === cookie ? {...i, status: value} : i,
                ),
              )
            }
          />
          <Estatico
            handleChangeCookie={(cookie: string, value: boolean) =>
              setCookiesState(prevState =>
                prevState.map(i =>
                  i.name === cookie ? {...i, status: value} : i,
                ),
              )
            }
          />
          <Publicidade
            handleChangeCookie={(cookie: string, value: boolean) =>
              setCookiesState(prevState =>
                prevState.map(i =>
                  i.name === cookie ? {...i, status: value} : i,
                ),
              )
            }
          />
          <NaoClassificados
            handleChangeCookie={(cookie: string, value: boolean) =>
              setCookiesState(prevState =>
                prevState.map(i =>
                  i.name === cookie ? {...i, status: value} : i,
                ),
              )
            }
          />
        </div>
        <div className={styles.footer}>
          <McButton
            slot="primaryAction"
            appearance="primary"
            variant="filled"
            fit="small"
            onClick={() => saveCustom()}>
            Salvar preferências
          </McButton>
        </div>
      </McModal>
    </div>
  )
}

export default CookiesConsent
